export default __webpack_public_path__ + "static/media/UniSansHeavyItalic.c0f5f33b.otf";